import React from 'react';

import { MCButton, MCError } from 'src/components/basic';
import { lang, remCss } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import { MediaOrderDropBox } from 'src/components/complex';

export const EditMedia = ({ closeBtn, item, onSave, hide, isMain }) => {
  const [media, setMedia] = React.useState(item?.media || []);
  const [loading, setLoading] = React.useState(false);
  const [invalid, setInvalid] = React.useState({});

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await onSave({ ...item, media, isMain });

    if (result.ok) {
      hide();
    } else if (result.invalid) {
      setInvalid(result.invalid);
    }

    setLoading(false);
  };

  const aspect = isMain ? 16 / 9 : 3 / 4;

  return (
    <form
      className='mc-popup-contain'
      onSubmit={save}
      style={{ maxWidth: remCss(isMain ? 645 : 608), height: '100%' }}
    >
      <div className='mc-modal-header'>
        <pre className='mc-popup-title'>{lang.t(LANG_CONST.media)}</pre>
        {closeBtn}
      </div>
      <div className='mc-modal-body mc-flex-15-col mc-grow'>
        <MediaOrderDropBox
          styles={{ width: isMain ? 100 * aspect : 120, height: isMain ? 100 : 120 / aspect }}
          accept={{ 'image/*': [], 'video/*': [] }}
          dropImage={{ aspect }}
          value={media}
          onChange={(v) => {
            setInvalid({});
            setMedia(v);
          }}
        />
      </div>
      <div className='mc-modal-footer mc-flex'>
        <div className='mc-grow'>
          {invalid?.media && <MCError label={LANG_CONST.media} error={invalid?.media} />}
        </div>
        <MCButton
          medium
          primary
          radius
          dark
          style={{ minWidth: remCss(110) }}
          disabled={loading}
          loading={loading}
          type={'submit'}
          label={LANG_CONST.buttons.save}
        />
      </div>
    </form>
  );
};
